import { useState } from 'react';
import axiosInstance from '../../../ns_libs/nsAxios';
import API_ENDPOINTS from '../../../services/urls';

interface DownloadTemplateResponse {
    url: string;
}

interface UseGetBulkUploadTemplateOptions {
    onError?: (error: unknown) => void;
}

const useGetBulkUploadTemplate = (organizationId?: string, options?: UseGetBulkUploadTemplateOptions) => {
    const [isDownloading, setIsDownloading] = useState(false);

    const handleDownload = async () => {
        setIsDownloading(true);
        try {
            if (!organizationId) {
                throw new Error('Organization ID is required');
            }
            const response = await axiosInstance.get<DownloadTemplateResponse>(API_ENDPOINTS.DEALS_BULK_UPLOAD.TEMPLATE(organizationId));
            const link = document.createElement('a');
            link.href = response.data.url;
            link.setAttribute('download', 'Northspyre Deal Bulk Upload Template.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error: unknown) {
            if (options?.onError) {
                options.onError(error);
            } else {
                throw error;
            }
        } finally {
            setIsDownloading(false);
        }
    };

    return {
        handleDownload,
        isDownloading,
    };
};

export default useGetBulkUploadTemplate;
